export const FETCH_CALLBACKS = 'FETCH_CALLBACKS';